import { ApiConfig, ServiceApi } from './ServiceApi';
import axios from 'axios';
import {
  AccountList,
  AccountsRequest,
  OTPConfirmRequest,
  UserManageVerifyRequest,
  UserVerifyRequest,
  LoanDetail,
} from '../models/RequestModel';
import { LoanDetailResponse } from '../models/ResponseModel';

export const postVerification = async (request: UserVerifyRequest | UserManageVerifyRequest) => {
  const response = await axios.post(ServiceApi.VERIFICATION, request, ApiConfig);
  return response.data;
};

export const postOTPConfirm = async (request: OTPConfirmRequest) => {
  const response = await axios.post(ServiceApi.OTP_CONFIRM, request, ApiConfig);
  return response.data;
};

export const postListAccount = async (request: AccountsRequest) => {
  const response = await axios.post(ServiceApi.LIST_ACCOUNT, request, ApiConfig);
  return response.data;
};

export const postRegisterAccount = async (request: AccountList) => {
  const response = await axios.post(ServiceApi.REG_ACCOUNT, request, ApiConfig);
  return response.data;
};

export const getLoanDetail = async (request: LoanDetail) => {
  const config = { headers: { accountNumber: request.accountNo, accountType: request.type } };
  const response = await axios.get<LoanDetailResponse>(ServiceApi.LOAN_DETAIL, config);
  return response.data;
};
